<template>
  <div class="home">
    <the-header></the-header>
    <v-container>
      <the-intro-text></the-intro-text>
      <div class="bg">
        <v-img class="bg-1" src="@/assets/img/flag6.jpg"></v-img>
      </div>
      <the-video-box></the-video-box>
      <div class="bg">
        <v-img class="bg-2" src="@/assets/img/flag2.jpg"></v-img>
      </div>
      <the-concert-box></the-concert-box>
      <the-congratulations-box></the-congratulations-box>
      <the-graduates-list id="laureats"></the-graduates-list>
      <div class="bg">
        <v-img class="bg-3" src="@/assets/img/flag1.jpg"></v-img>
      </div>
    </v-container>
  </div>
</template>

<style lang="scss">
.container:not(.container--fluid) {
  max-width: 1500px !important;
}
</style>

<script>
import TheConcertBox from '@/components/TheConcertBox'
import TheCongratulationsBox from '@/components/TheCongratulationsBox'
import TheIntroText from '@/components/TheIntroText'
import TheGraduatesList from '@/components/TheGraduatesList'
import TheHeader from '@/components/TheHeader'
import TheVideoBox from '@/components/TheVideoBox'

export default {
  mounted() {
    if (this.$route.hash) {
      const el = document.getElementById(this.$route.hash.slice(1))
      if (el) {
        window.scrollTo(0, el.offsetTop)
      }
    }
  },
  components: {
    TheConcertBox,
    TheCongratulationsBox,
    TheIntroText,
    TheGraduatesList,
    TheHeader,
    TheVideoBox
  }
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.home {
  overflow: hidden;
}

.bg {
  position: relative;
}

.bg-1 {
  position: absolute;
  right: -12px;
  transform: translate(60%, -20%);

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    transform: translate(30%, -20%);
  }
}

.bg-2 {
  position: absolute;
  left: -12px;
  transform: translate(-40%, -10%);

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    transform: translate(-20%, -10%);
  }
}

.bg-3 {
  position: absolute;
  right: -12px;
  transform: translate(30%, -31%);

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    transform: translate(10%, -40%);
  }
}
</style>
